import type { RgbColor } from "utils/hslToRgb";
import { NO_ZONE_RGB } from "../constants";
import { shadeRoomColor } from "../shadeRoomColor";
import type { BuildRoomColorMap } from "./types";

// Each room gets a shade of its zone colour; rooms without a known zone stay grey.
export const buildRoomColorMap: BuildRoomColorMap = ({
  rooms,
  zoneColorById,
}) => {
  const roomCountByZoneId = new Map<number, number>();
  for (const room of rooms) {
    if (room.zoneId === null) continue;
    roomCountByZoneId.set(
      room.zoneId,
      (roomCountByZoneId.get(room.zoneId) ?? 0) + 1,
    );
  }

  const nextPositionByZoneId = new Map<number, number>();
  const colorByRoomId = new Map<number, RgbColor>();
  for (const room of rooms) {
    const zoneRgb =
      room.zoneId === null ? undefined : zoneColorById.get(room.zoneId);
    if (room.zoneId === null || zoneRgb === undefined) {
      colorByRoomId.set(room.id, NO_ZONE_RGB);
      continue;
    }
    const position = nextPositionByZoneId.get(room.zoneId) ?? 0;
    nextPositionByZoneId.set(room.zoneId, position + 1);
    colorByRoomId.set(
      room.id,
      shadeRoomColor({
        rgb: zoneRgb,
        position,
        count: roomCountByZoneId.get(room.zoneId) ?? 1,
      }),
    );
  }
  return colorByRoomId;
};
